import React, { useEffect } from "react";
import "./Projects.css";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useDispatch } from "react-redux";
import { fetchProjects } from "../store/ProjectsSlice";
import ProjectCard from "../components/ProjectCard";

const Projects = () => {
  const dispatch = useDispatch();
  const projects = useSelector((state) => state.projects.projects);

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  return (
    <div className="projects" id="projects">
      <h1 className="title projects-title">Featured projects</h1>
      <div className="projects-container">
        {projects.map((project, id) => (
          <ProjectCard
            key={id}
            image={`project-imagines/${project.image_url}.png`}
            title={project.project_name}
            description={project.description}
            stacks={project.tech_stack}
            source_link={project.source_link}
            new={project.new}
          />
        ))}
      </div>
    </div>
  );
};

export default Projects;
